import { createAsyncThunk } from "@reduxjs/toolkit";
import { raiseError, response as successAction } from "../actions/action";
import apiRequest from "./apiRequest";

const createRazorpayOrder = createAsyncThunk('/payment/create-order', async (amount, { dispatch }) => {
  try {
    const response = await apiRequest.post(`/payment/create-order`, { amount });
    return response.data;
  } catch (error) {
    dispatch(raiseError("Failed to initiate payment. Please try again."));
    return null;
  }
});

const checkout = createAsyncThunk('/checkout', async (checkoutDetails, { dispatch }) => {
  try {
    const response = await apiRequest.post(`/checkout`, checkoutDetails);
    return response.data;
  } catch (error) {
    dispatch(raiseError("Something went wrong. please try after sometime"));
  }
});

const fetchOrders = createAsyncThunk('/fetchOrders', async (userData, { dispatch }) => {
  try {
    const response = await apiRequest.get(`/checkout/${userData.userId}?IsAdmin=${userData?.isAdmin || false}`);
    return response.data;
  } catch (error) {
    dispatch(raiseError("Something went wrong. please try after sometime"));
  }
});

const updateOrderStatus = createAsyncThunk('/checkout/updateStatus', async ({ orderId, status }, { dispatch }) => {
  try {
    await apiRequest.put(`/checkout/${orderId}/status`, { Status: status });
    dispatch(successAction(`Order ${orderId} status updated to ${status}`));
    return { orderId, status };
  } catch {
    dispatch(raiseError("Failed to update order status."));
    return null;
  }
});

export { checkout, fetchOrders, createRazorpayOrder, updateOrderStatus };
